import React from 'react';
import { CheckCircle2, AlertCircle } from 'lucide-react';
interface ActivityProgressBadgeProps {
  currentStep: number;
  totalSteps?: number;
  percentage: number;
  isCompleted: boolean;
  isOverdue: boolean;
  size?: 'sm' | 'md';
}
export function ActivityProgressBadge({
  currentStep,
  totalSteps = 5,
  percentage,
  isCompleted,
  isOverdue,
  size = 'sm'
}: ActivityProgressBadgeProps) {
  if (isCompleted) {
    return <div className={`flex items-center gap-1.5 ${size === 'sm' ? 'text-xs' : 'text-sm'}`} data-id="element-482" data-mp="1gp3eqhxi3fth">
        <CheckCircle2 className={`${size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} text-green-500`} data-id="element-483" data-mp="1brtq34hxr86p" />
        <span className="font-semibold text-green-700" data-id="element-484" data-mp="16yieyr63c58z">Completata</span>
        <span className="text-green-500 font-medium" data-id="element-485" data-mp="120qq660qsz90">100%</span>
      </div>;
  }
  if (isOverdue) {
    return <div className="space-y-1" data-id="element-486" data-mp="1zi7aq9y6y4r9">
        <div className={`flex items-center gap-1.5 ${size === 'sm' ? 'text-xs' : 'text-sm'}`} data-id="element-487" data-mp="1uqfrylla13bo">
          <AlertCircle className={`${size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} text-red-500`} data-id="element-488" data-mp="lg1vpkj3n1ed" />
          <span className="font-semibold text-red-700" data-id="element-489" data-mp="qemurgmm7f18">Scaduta</span>
          <span className="text-red-500 font-medium" data-id="element-490" data-mp="br1pph66j5qo">
            Step {currentStep}/{totalSteps} · {percentage}%
          </span>
        </div>
        <div className={`w-full bg-red-100 rounded-full ${size === 'sm' ? 'h-1' : 'h-1.5'} overflow-hidden`} data-id="element-491" data-mp="goabrsug7tx7">
          <div className="bg-red-500 h-full rounded-full transition-all duration-300" style={{
          width: `${percentage}%`
        }} data-id="element-492" data-mp="2sge65z4kqze" />
        </div>
      </div>;
  }
  return <div className="space-y-1" data-id="element-493" data-mp="3tvv93qi4vwr7">
      <div className={`flex items-center gap-1.5 ${size === 'sm' ? 'text-xs' : 'text-sm'}`} data-id="element-494" data-mp="3tx6e1tnbfajw">
        <span className="font-medium text-slate-600" data-id="element-495" data-mp="1n6gngn67q1mu">
          Step {currentStep}/{totalSteps}
        </span>
        <span className="font-semibold text-seform-orange" data-id="element-496" data-mp="1s48oc6ou4y36">{percentage}%</span>
      </div>
      <div className={`w-full bg-slate-100 rounded-full ${size === 'sm' ? 'h-1' : 'h-1.5'} overflow-hidden`} data-id="element-497" data-mp="1qpfpp0f6x3vg">
        <div className="bg-seform-orange h-full rounded-full transition-all duration-300" style={{
        width: `${percentage}%`
      }} data-id="element-498" data-mp="1lr4ikxga57gx" />
      </div>
    </div>;
}